module.exports = __webpack_public_path__ + "media/images/checkout/challenger/unit_10x20-d504bc383989919f7a12f996e9505eef.png";